import styled from 'styled-components'

import { Box } from '@redriverpress/system'

const HitWrapper = styled(Box).attrs(() => ({
  bg: 'white',
  borderRadius: 'rounded',
  position: 'relative',
  boxShadow: 2,
}))`
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: ${props => props.theme.shadows[2]};
    opacity: 0;
    transition: opacity 0.3s ease-out;
  }

  &:hover:after {
    opacity: 1;
  }
`

HitWrapper.displayName = 'HitWrapper'

export default HitWrapper
